import React, { useMemo, useState, useEffect, useContext, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { GET_IMPORT_PRODUCT_GROUP_MONTHLY_REPORT, GET_PRODUCT_WISE_IMPORT_MONTHLY, } from "../../../services/apiRoutes";
import { AuthContext } from "../../../context/AuthContext";
import CustomLoader from "../../common/CustomLoader";
import CustomReport from "../../common/CustomReport";
import { genericPost } from "../../../services/authServices";
import CustomDataTable from "../../common/CustomDataTable";

import CustomFilter from "../../common/CustomFilter";
import CustomAutocomplete from "../../common/CustomAutoComplete";
import CustomButton from "../../common/CustomButton";
import { Box, Grid } from "@mui/material";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded } from "@mui/icons-material";

const title = "import product monthly report";

const ProductwiseimportreportView = () => {
    const { productsId } = useParams();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    // ✅ NEW: Financial Year Filter State
    const currentYear = new Date().getFullYear();
    const financialYearOptions = Array.from({ length: 10 }, (_, i) => {
        const start = currentYear - i;
        const end = start + 1;
        return {
            label: `${start}-${String(end).slice(2)}`,
            value: `${start}-${String(end).slice(2)}`
        };
    });

    // ✅ Get Current Financial Year (April → March)
    const getCurrentFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0 = Jan, 11 = Dec

        // Financial year starts from April (month = 3)
        if (month >= 3) {
            // April to December → currentYear-nextYear
            const nextYearShort = String(year + 1).slice(2);
            return `${year}-${nextYearShort}`;
        } else {
            // Jan to March → previousYear-currentYear
            const prevYear = year - 1;
            const currentYearShort = String(year).slice(2);
            return `${prevYear}-${currentYearShort}`;
        }
    };
    const [filterPayload, setFilterPayload] = useState({
        // financialYear: "",
        financialYear: getCurrentFinancialYear(),

    });

    // ✅ NEW
    const [openDrawer, setOpenDrawer] = useState(false);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);

    // ✅ NEW
    const handleApplyFilter = () => {
        setPage(0);
        fetchData(0, pageSize);
    };

    const handleClearFilters = () => {
        setFilterPayload({
            financialYear: "",
        });
        setPage(0);
        fetchData(0, pageSize);
    };
    // ✅ NEW
    const handleFilterChange = (value) => {
        setFilterPayload({
            financialYear: value || "",
        });
    };

    const columns = useMemo(() => [
        {
            accessorKey: 'index',
            header: 'SN',
            size: 50,
            tableStyle: { textAlign: "center" },
        },
        {
            accessorKey: 'monthName',
            header: 'Month',
            size: 120,
            tableStyle: { textAlign: "center" },
        },
        {
            accessorKey: 'productName',
            header: 'Product Name',
            size: 200,
            tableStyle: { textAlign: "center" },
        },
        {
            accessorKey: 'qty',
            header: 'Qty',
            size: 120,
            tableStyle: { textAlign: "center" },
        },
        {
            accessorKey: 'primaryQty',
            header: 'Primary Qty',
            size: 150,
            tableStyle: { textAlign: "center" },
        },
        {
            accessorKey: 'secondaryQty',
            header: 'Secondary Qty',
            size: 150,
            tableStyle: { textAlign: "center" },
        },

    ], []);


    const fetchData = async (pageIndex = page, pageLimit = pageSize) => {

        if (!pageLimit || pageLimit <= 0) pageLimit = 10;
        if (!pageIndex || pageIndex < 0) pageIndex = 0;

        setLoading(true);

        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageLimit,
                productsId: productsId,
                financialYear: filterPayload.financialYear,
            };

            const response = await genericPost(GET_PRODUCT_WISE_IMPORT_MONTHLY, payload);

            if (response.data.success && Array.isArray(response.data.products)) {

                const { products, pagination } = response.data;

                // ✅ TAKE SINGLE PRODUCT (since productsId passed)
                const product = products[0];

                // ✅ MAP MONTHLY DATA
                const mappedData = product.monthlyReport.map((item) => ({
                    index: item.index,
                    monthName: item.monthName,
                    productName: product.productName, // ✅ ADD THIS


                    // ✅ Already formatted from backend
                    qty: item.qty,
                    primaryQty: item.primaryQty,
                    secondaryQty: item.secondaryQty,
                }));

                setData(mappedData);
                setRowCount(pagination?.totalRecords || 0);

            } else {
                setData([]);
            }

        } catch (err) {
            console.error("Fetch Error:", err);
            setError(err.message);
            setData([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData(page, pageSize)
    }, [page, pageSize, token,])


    const defaultView = 'productwiseimportreport';

    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Filter"

            />
            {/* ✅ NEW FILTER UI */}
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <Box>
                        <Grid container spacing={1}>

                            <Grid item xs={12}>
                                <CustomAutocomplete
                                    options={financialYearOptions}
                                    getOptionLabel={(option) => option.label}
                                    placeholder="Select Financial Year"
                                    onChange={(event, newValue) =>
                                        handleFilterChange(newValue?.value)
                                    }
                                    value={
                                        financialYearOptions.find(
                                            (item) => item.value === filterPayload.financialYear
                                        ) || null
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sx={{ display: "flex", gap: "10px", mt: 2 }}>
                                <CustomButton
                                    startIcon={<FindReplaceOutlinedIcon />}
                                    title="Apply"
                                    size="small"
                                    variant="contained"
                                    onClick={handleApplyFilter}
                                />
                                <CustomButton
                                    variant="outlined"
                                    title="Clear"
                                    startIcon={<ClearRounded />}
                                    onClick={handleClearFilters}
                                />
                            </Grid>

                        </Grid>
                    </Box>
                }
            />

        </>
    );
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={mainContent} />
        </>
    );
};

export default ProductwiseimportreportView;
